<template>
  <v-dialog
    v-model="avgRankingBreakoutDialog"
    :fullscreen="$vuetify.display.xs"
    persistent
    scrollable
    width="600px"
  >
    <v-card>
      <!-- Header -->
      <v-card-title>Avg 13F Ranking Rule</v-card-title>
      <!-- Body -->
      <v-card-text style="height: 450px">
        <p>Use the average 13F ranking as a breakout signal</p>

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="editedModel.enabled"
              density="compact"
              variant="outlined"
              label="Rule Enabled"
            />
          </v-col>
          <v-row density="compact">
            <v-col cols="12">
              <v-radio-group v-model="editedModel.direction" class="mt-0">
                <v-radio
                  :value="1"
                  label="Avg. 13F Ranking is >= the lowest Avg. 13F Ranking of specific # of quarters below:"
                />
                <v-radio
                  :value="2"
                  label="Avg. 13F Ranking is <= the lowest Avg. 13F Ranking of specific # of quarters below:"
                />
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="12" md="7">
              <v-text-field
                v-model="editedModel.number_of_quarters"
                density="compact"
                hide-details
                variant="outlined"
                label="Avg of Past # of Quarters to look at"
              />
            </v-col>
            <v-col cols="12" sm="12" md="7">
              <v-text-field
                v-model="editedModel.change_min"
                density="compact"
                hide-details
                variant="outlined"
                prefix="by at least"
                label="optional minimum change % from prior quarter"
              />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedModel.ranking_min"
                density="compact"
                hide-details
                variant="outlined"
                label="optional min. Avg Ranking"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedModel.ranking_max"
                density="compact"
                hide-details
                variant="outlined"
                label="optional max. Avg Ranking"
              />
            </v-col>
          </v-row>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn color="blue-darken-1" text @click="cancel"> Cancel </v-btn>
        <v-btn color="blue-darken-1" text @click="save"> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { mapStoreState, mapFields } from '@/store/helpers'
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Mixins
import cloneDeep from 'lodash/cloneDeep'
export default {
  mixins: [],
  props: {
    whaleTrader: Boolean,
    buySellIndicator: String
  },
  data: () => ({
    searching: false,
    items: null,
    avgRankingBreakoutDialog: false,
    editedIndex: -1,
    defaultAvgRanking: {
      enabled: true,
      direction: 1,
      number_of_quarters: '8',
      change_min: '5',
      ranking_min: null,
      ranking_max: null,
      long_short: 'long'
    },
    editedModel: {}
  }),

  computed: {
    editModel() {
      return this.$parent.editedAvgRanking
    }
  },

  watch: {},
  mounted() {
    this.initializeAvgRanking()
  },

  methods: {
    initializeAvgRanking() {
      this.editedModel = cloneDeep(this.defaultAvgRanking)
    },
    show(item, items) {
      this.items = items
      if (item) {
        this.editedIndex = items.indexOf(item)
        this.editedModel = Object.assign({}, item)
      } else {
        this.initializeAvgRanking()
        this.editedIndex = -1
      }
      this.avgRankingBreakoutDialog = true
    },
    cancel() {
      this.avgRankingBreakoutDialog = false
      this.editedIndex = -1
      this.initializeAvgRanking()
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedModel)
      } else {
        this.items.push(this.editedModel)
      }
      this.cancel()
    },
    deleteRanking(item, items) {
      const index = items.indexOf(item)
      confirm('Are you sure you want to delete this rule?') && items.splice(index, 1)
    }
  }
}
</script>
